import React from 'react';

import {
  AssaySchemaFieldTableRow,
  AssaySchemaFieldTableRowProps,
} from 'results/assay-schemas/AssaySchemaFieldTableRow';

export function ConnectionSchemaFieldTableRow(
  props: Omit<AssaySchemaFieldTableRowProps, 'includeSnapshotField'>
): JSX.Element {
  return <AssaySchemaFieldTableRow {...props} includeSnapshotField={false} />;
}
